import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useEffect, useMemo, useState } from "react";
import { UseColumnsErrores } from "../utils/columnsErrores";
import Tabla from '../../../../components/ui/materialui/tabla';
import { ErroresArchivosExcel } from "../models/erroresArchivoExcel";
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';

interface IProps{
    show: boolean,
    onHide: () => void;
    errores: string;
}

export const ModalErrorExcelMasivo = ({show, onHide, errores} : IProps) => {

    const [data, setData] = useState<ErroresArchivosExcel[]>([])

    const claveArchivo = "ERROR ARCHIVO";
    const claveRecaudacion = "ERROR RECAUDACION";

    const isClaveArchivo = errores.includes(claveArchivo);
    const isClaveRecaudacion = errores.includes(claveRecaudacion)


    useEffect(() => {
        if (show && errores && errores != ""){
            const errorList : ErroresArchivosExcel[] = []
            const errorCleaned = isClaveArchivo ? errores.substring(claveArchivo.length) : 
                                 isClaveRecaudacion ? errores.substring(claveRecaudacion.length) : errores
            const erroresLinea = errorCleaned.split(";")

            for (const linea of erroresLinea){
                const lineaSplit = linea.split(":")
                const celda = lineaSplit.length > 0 ? lineaSplit[0] : "";
                const descripcion = lineaSplit.length > 1 ? lineaSplit[1]: ""
                const numeroLinea = lineaSplit.length > 2 ? parseInt(lineaSplit[2]): 0
                const errorIndex : ErroresArchivosExcel = {celda, descripcion, numeroLinea}
                errorList.push(errorIndex)
            }

            if (isClaveRecaudacion){
                errorList.sort((a, b) => {
                    return a.numeroLinea - b.numeroLinea
                });
            }

            setData(errorList)
        }
    }, [show, errores])

    const { COLUMNS_ERRORES } = UseColumnsErrores({isArchivo: isClaveArchivo});
    const columns = useMemo(() => COLUMNS_ERRORES, [isClaveArchivo]);

    return(
        <Dialog open={show} onClose={onHide} maxWidth="lg">
            <DialogTitle>
                { isClaveArchivo ? "Errores de carga" : "Errores de verificación" }
            </DialogTitle>
            <DialogContent>
                <Tabla
                    data={data}
                    columns={columns}
                />
                <Grid2 container size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "10px" }} spacing={3}>
                    <MButton variant="contained" color="primary" onClick={onHide}>
                        Cerrar
                    </MButton>
                </Grid2>
            </DialogContent>
        </Dialog>
    )
}